<section class="security-flow">
  <div class="security-flow__content">
    <div class="field">
      <label for="securityCurrentPassword">{{ 'app.profileSettings.securityModal.password.currentPassword' | translate }}</label>
      <p>{{ 'app.profileSettings.securityModal.password.currentPasswordHelp' | translate }}</p>
      <div class="password-input">
        <input id="securityCurrentPassword" [type]="showCurrentPassword() ? 'text' : 'password'" [ngModel]="model().currentPassword"
          (ngModelChange)="onCurrentPasswordChange($event)" />
        <button type="button" class="password-input__toggle" (click)="toggleCurrentPasswordVisibility()"
          [attr.aria-label]="(showCurrentPassword() ? 'app.profileSettings.securityModal.password.hidePassword' : 'app.profileSettings.securityModal.password.showPassword') | translate">
          <app-icon [icon]="showCurrentPassword() ? 'icon-eye-off-regular.svg' : 'icon-eye-on-solid.svg'" color="var(--safegpt-text-muted)" [width]="18" [height]="18" />
        </button>
      </div>
    </div>

    <div class="field">
      <label for="securityNewPassword">{{ 'app.profileSettings.securityModal.password.newPassword' | translate }}</label>
      <p>{{ 'app.profileSettings.securityModal.password.newPasswordHelp' | translate }}</p>
      <div class="password-input">
        <input id="securityNewPassword" [type]="showNewPassword() ? 'text' : 'password'" [ngModel]="model().newPassword"
          (ngModelChange)="onNewPasswordChange($event)" />
        <button type="button" class="password-input__toggle" (click)="toggleNewPasswordVisibility()"
          [attr.aria-label]="(showNewPassword() ? 'app.profileSettings.securityModal.password.hidePassword' : 'app.profileSettings.securityModal.password.showPassword') | translate">
          <app-icon [icon]="showNewPassword() ? 'icon-eye-off-regular.svg' : 'icon-eye-on-solid.svg'" color="var(--safegpt-text-muted)" [width]="18" [height]="18" />
        </button>
      </div>
      <app-password-strength class="password-strength-meter" [passwordToCheck]="model().newPassword" [showRequirements]="true" />
    </div>

    <div class="field">
      <label for="securityConfirmPassword">{{ 'auth.passwordResetConfirm.confirmPassword.label' | translate }}</label>
      <p>{{ 'app.profileSettings.securityModal.password.confirmPasswordHelp' | translate }}</p>
      <div class="password-input">
        <input id="securityConfirmPassword" [type]="showConfirmPassword() ? 'text' : 'password'" [ngModel]="confirmPassword()"
          (ngModelChange)="onConfirmPasswordChange($event)" />
        <button type="button" class="password-input__toggle" (click)="toggleConfirmPasswordVisibility()"
          [attr.aria-label]="(showConfirmPassword() ? 'app.profileSettings.securityModal.password.hidePassword' : 'app.profileSettings.securityModal.password.showPassword') | translate">
          <app-icon [icon]="showConfirmPassword() ? 'icon-eye-off-regular.svg' : 'icon-eye-on-solid.svg'" color="var(--safegpt-text-muted)" [width]="18" [height]="18" />
        </button>
      </div>
      @if (passwordsMismatch()) {
      <p class="field-error">{{ 'auth.passwordResetConfirm.notifications.passwordMismatch' | translate }}</p>
      }
    </div>
  </div>

  <footer class="security-flow__footer">
    <button type="button" class="safegpt-button inverted" (click)="cancelled.emit()">{{ 'common.actions.back' | translate }}</button>
    <button type="button" class="safegpt-button" [disabled]="!canSubmit()" (click)="onSaveClick()">
      {{ 'app.profileSettings.securityModal.password.submit' | translate }}
    </button>
  </footer>
</section>

